import { TextField } from "@walmart-web/livingdesign-components"
import TrailingShowPassword from "components/ResetPassword/ResetPasswordForm/TrailingShowPassword"
import React, { useState } from "react"
import { useIntl } from "react-intl"

interface PasswordInputProps {
	value: string
	onChange: (value: string) => void
	label: string
	id: string
	disabled?: boolean
}

const PasswordInput: React.FC<PasswordInputProps> = ({
	label,
	value,
	onChange,
	disabled,
	id,
}) => {
	const intl = useIntl()
	const [showPassword, setShowPassword] = useState(false)

	return (
		<>
			<label
				htmlFor={id}
				className={"label " + (disabled ? "label-disabled" : "")}
			>
				{intl.formatMessage({
					id: label,
				})}
			</label>
			<TextField
				label={null}
				id={id}
				type={showPassword ? "text" : "password"}
				data-testid="input-code"
				className="input"
				value={value}
				disabled={disabled}
				trailing={
					<TrailingShowPassword
						a11yLabel="Show password"
						actionClick={() => setShowPassword(!showPassword)}
						isVisible={showPassword}
					/>
				}
				onChange={(e) => onChange(e.currentTarget.value)}
			/>
		</>
	)
}

export default PasswordInput
